
  customElements.define('currency-select', class CurrencySelect extends HTMLElement {
      constructor() {
        super();

        this.currencies = this.querySelectorAll('.set-currency');
        this._self = this;

        this.currencies.forEach(el => el.addEventListener('click', event => {
          event.preventDefault();
      
          if (!event.target.classList.contains('selected')) {
              const sel = this._self.querySelector('#currency');
      
              var opts = sel.options;
              for (var opt, j = 0; opt = opts[j]; j++) {
                  if (opt.value == el.dataset.currency) {
                    sel.selectedIndex = j;
                    sel.parentElement.submit();
                    break;
                  }
              }
          }

          return;
        }));
      }
  }) 
